import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import * as moment from 'moment-timezone';
import { NoProviderService } from 'src/app/shared/gantt/interfaces/NoProviderService.model';

@Component({
  selector: 'app-no-provider-service-card',
  templateUrl: './no-provider-service-card.component.html',
  styleUrls: ['./no-provider-service-card.component.css'],
})
export class NoProviderServiceCardComponent implements AfterViewInit {
  @Input() Service: NoProviderService | undefined;
  @Input() Selectable: boolean = false;
  @Input() EnableEditHour: boolean = false;
  @Input() ShowServiceTitle: boolean = false;
  @Output() assignProviderEmitter = new EventEmitter<string>();
  @Output() ShowMoreCommentEmitter = new EventEmitter();

  moment = moment;

  IsEditingHour: boolean = false;
  HourEditing: string = '';

  constructor() {}

  assignProvider(orderHash: string) {
    this.assignProviderEmitter.emit(orderHash);
  }

  // editHour() {
  //   if (this.EnableEditHour && this.Service) {
  //     this.IsEditingHour = true;
  //     this.HourEditing = this.Service.PickUpHourStart;
  //   }
  // }

  // saveHour() {
  //   this.IsEditingHour = false;
  //   if (this.Service) {
  //     this.Service.PickUpHourStart = this.HourEditing;
  //   }
  // }

  updateHourValue(event: Event): void {
    const input = event.target as HTMLInputElement;
    const rawValue = input.value;

    // Elimina solo la 'h' del final si existe
    const cleaned = rawValue.endsWith('h') ? rawValue.slice(0, -1) : rawValue;

    this.HourEditing = cleaned;

    // Reescribe el valor con 'h' para mantener formato
    input.value = this.HourEditing + 'h';
  }

  expanded = false;
  isOverflowing = true;
  @ViewChild('textElement') textElement!: ElementRef;
  ngAfterViewInit() {
    setTimeout(() => {
      // Esperar renderizado
      const el = this.textElement.nativeElement;
      this.isOverflowing = el.scrollHeight > el.clientHeight;
    });
  }
  toggleExpand(event: Event) {
    event.stopPropagation();
    this.expanded = !this.expanded;
    this.ShowMoreCommentEmitter.emit();
  }
}
